import React, { useCallback, useEffect, useMemo, useState } from 'react';
import {
	Dimensions,
	StyleSheet,
	TouchableHighlight,
	useWindowDimensions,
	View,
} from 'react-native';
import HeaderContainer from '../../../components/shared/Header/Header.container';
import I18n from '../../../components/shared/i18n/I18n.component';
import colors from '../../../config/colors';
import WebHeader from '../../../components/shared/Header/WebHeader.component';
import TableContainer from '../../../components/web/ReactTable/Table.container';
import Typography from '../../../components/shared/Typography/Typography.component';
import { i18nService } from '../../../services/i18n.service';
import Filters from '../../../components/web/Filters/Filters.component';
import getShadowStyle from '../../../config/shadow';
import { Columns } from './WorklogReportsPage.utils';
import ReportsPageWrapper from '../../../components/web/ReportsPageWrapper/ReportsPageWrapper.component';
import ImageIcon from '../../../components/shared/Icon/ImageIcon.component';
import ButtonV2 from '../../../components/shared/Buttons/ButtonV2.container';

export interface WorklogReportsPageProps {
	navigation: any;
	data: any[];
	onSort?: any;
	currentEmployee: any;
	onLoadMore: any;
	totalData: any;
	filtersConfig1: any;
	filtersConfig2: any;
	isSelectMode: boolean;
	selectedRows: any[];
	isAllSelected: boolean;
	worklogReportFormat: any;
	onSelectAll: (cheacked: boolean) => {};
	onSelect: () => {};
	onConfirmSelect: () => {};
	onCancelSelect: () => {};
	reqForSelect: () => {};
	onFilter: () => {};
	onDelete: (id: any) => {};
	onShowHistory: (row: object) => {};
	onEdit: (id: any) => {};
	backTohoursReportSummery: () => void;
	onAddNewLog: () => void;
	canEdit: boolean;
	businessUnitsList: any[];
}

const WorklogReportsPage = ({
	onAddNewLog,
	navigation,
	backTohoursReportSummery,
	data,
	totalData,
	onSort,
	onLoadMore,
	filtersConfig1,
	filtersConfig2,
	isSelectMode,
	selectedRows,
	isAllSelected,
	onSelectAll,
	onSelect,
	onConfirmSelect,
	onCancelSelect,
	reqForSelect,
	onFilter,
	onEdit,
	onDelete,
	onShowHistory,
	worklogReportFormat,
	canEdit,
	businessUnitsList,
}: WorklogReportsPageProps) => {
	const { height: windowHeight } = useWindowDimensions();
	const [isSmallDimensions, setIsSmallDimensions] = useState(
		window.innerWidth <= 1600,
	);

	return (
		<>
			<HeaderContainer
				navigation={navigation}
				containerStyle={{ backgroundColor: colors.white }}
				component={WebHeader}
			/>
			<ReportsPageWrapper
				navigation={navigation}
				title={
					<View
						style={{
							flexDirection: 'row-reverse',
							alignItems: 'center',
							paddingRight: isSmallDimensions ? 11 : 0,
							paddingBottom: isSmallDimensions ? 9 : 17,
							width: '100%',
						}}
					>
						<View style={{ flexDirection: 'row-reverse', alignItems: 'center' }}>
							<ImageIcon name="clockInLogo" width={108} height={30} style={{marginLeft: 12}} />
							<I18n
								size={20}
								weight='bold'
								color='primaryDarkBlue'
								style={{ flex: 4 }}
							>
								reportView.reportsTitle
							</I18n>
						</View>

						<View
							style={{
								flexDirection: 'row-reverse',
								flex: 1,
								justifyContent: 'flex-end',
							}}
						>
							<ButtonV2
								preset='primary'
								onPress={() => backTohoursReportSummery()}
								overrideStyle={{width: 'auto', marginLeft: 8}}
							>								
								<I18n color='white' weight='400' size={14}>hoursReport.toAllHoursReports</I18n>				
							</ButtonV2>
							{isSelectMode ? (
								<View style={{ flexDirection: 'row', gap: 8 }}>							
									<ButtonV2
									preset='primary'
									onPress={() => onConfirmSelect()}
									disabled={false}
								>
									<Typography
										color={'white'}
										weight='400'
										size={14}
									>
										{i18nService.translate('employeeHoursReport.confirmFilterButton')}
									</Typography>
								</ButtonV2>
								
								<ButtonV2
									preset='outline'
									onPress={() => onCancelSelect()}
									disabled={false}
								>
									<Typography
										color={'titlePrimary'}
										weight='400'
										size={14}
									>
										{i18nService.translate('employeeHoursReport.cancelFilterButton')}
									</Typography>
								</ButtonV2>
								</View>
							) : (

								<ButtonV2
								preset='outline'
								onPress={reqForSelect}
								disabled={!canEdit}
								overrideStyle={{width: 'auto'}}
							>
								<Typography
									color={'titlePrimary'}
									weight='400'
									size={14}
								>
									{i18nService.translate(
										'employeeHoursReport.reqForConfirmButton',
									)}
								</Typography>
								<ImageIcon name='checkedMark' color={colors.titlePrimary } style={{ marginLeft: 8 }} width={12} height={12}/>
							</ButtonV2>
							)}

							<ButtonV2 preset='primary' onPress={onAddNewLog} overrideStyle={{width: 'auto', marginRight: 10}}>
								<Typography color='white' weight='400' size={14}>
									{i18nService.translate('employeeHoursReport.addReport')}
								</Typography>
								<ImageIcon name='plus' color='white' style={{ marginLeft: 8 }} width={12} height={12} />
							</ButtonV2>
						</View>
					</View>
				}
				noHeader={true}
			>
				<View style={styles.tableHeader} nativeID='#tableHeader'>
					<View
						style={{ flexDirection: 'row-reverse', zIndex: 10001 }}
					>
						<Filters
							config={filtersConfig1}
							onChange={onFilter}
							customStyles={{
								container: {
									display: 'flex',
									flexDirection: 'row-reverse',
									justifyContent: 'flex-end',
									alignSelf: 'center',
								},
								filterContainer: {
									marginVertical: 5,
									marginLeft: 5,
									zIndex: 10001,
								},
							}}
						/>
					</View>
					<View
						style={{ flexDirection: 'row-reverse', zIndex: 1000 }}
					>
						<Filters
							config={filtersConfig2}
							onChange={onFilter}
							customStyles={{
								container: {
									display: 'flex',
									flexDirection: 'row-reverse',
									justifyContent: 'flex-end',
									alignSelf: 'center',
								},
								filterContainer: {
									marginBottom: 10,
									marginLeft: 5,
									zIndex: 1000,
								},
							}}
						/>
					</View>
					<View
						style={{
							maxHeight: windowHeight - 300,
						}}
					>
						<TableContainer
							keyName={'localId'}
							headers={Columns(
								totalData ? totalData.total : null,
								isSelectMode,
								selectedRows,
								isAllSelected,
								onSelectAll,
								onSelect,
								onDelete,
								onShowHistory,
								onEdit,
								worklogReportFormat,
								canEdit,
								businessUnitsList,
							)}
							data={data || []}
							getNextData={onLoadMore}
							onSort={onSort}
							hasFooter={true}
							selectedRowId={0}
						/>
					</View>
				</View>
			</ReportsPageWrapper>
		</>
	);
};

const styles = StyleSheet.create({
	tableHeader: {
		width: '100%',
		zIndex: 100,
	},
	filtersContainer: {
		flexDirection: 'row',
		width: '100%',
		// alignItems: 'center',
		// overflow: 'hidden'
	},

	fabButton: {
		borderRadius: 30,
		width: 40,
		height: 40,
		marginHorizontal: 10,
		...getShadowStyle(20, 'rgb(59, 112, 164)'),
	},
	newRequestButton: {
		flexDirection: 'row',
		alignItems: 'center',
		justifyContent: 'center',
		height: 40,
		paddingHorizontal: 3,
		marginLeft: 10,
		backgroundColor: colors.lightPrimary,
		borderRadius: 45,
		...getShadowStyle(20, 'rgb(59, 112, 164)'),
	},
});

export default WorklogReportsPage;
